<template>
  <div class="basics">
    <div class="basics-content">
      <div class="basics-title">
        <img src="../../assets/img/reader/basics.png" alt="" />
        <span class="title">基础资料</span>
      </div>
      <div class="basics-message">
        <div class="message-box">
          <span>用户账号</span>
          <span>|</span>
          <span style="letter-spacing: 1px;">{{ Name }}</span>
        </div>
        <div class="message-box">
          <span>用户昵称</span>
          <span>|</span>
          <span style="letter-spacing: 1px;">{{ detailsform.nickname }}</span>
          <span class="btn" style="left:514px" v-if="isShow" @click="unfoldBtn">展开</span>
          <span class="btn" style="left:514px" @click="collectBtn" v-if="!isShow">收起</span
          >
        </div>
        <div class="nickname" v-if="!isShow">
          <el-form ref="form" :model="form" label-width="84px">
            <el-form-item label="新昵称">
              <el-input v-model="form.nickname"></el-input>
            </el-form-item>
          </el-form>
          <el-button @click="nameBtn(form)">保存</el-button>
        </div>
        <div class="message-box pwd">
          <span>修改密码</span>
          <span>|</span>
          <!-- <span style="letter-spacing: 1px;">****</span> -->
          <span class="btn" v-if="pwdShow" style="left: 644px" @click="pwdUnfold">展开</span>
          <span class="btn" v-if="!pwdShow" style="left: 644px" @click="pwdCollect">收起</span>
        </div>
        <div class="passwd-box" v-if="!pwdShow">
          <el-form ref="form" :model="pwdform" label-width="110px">
            <el-form-item label="新密码">
              <el-input type="password" v-model="pwdform.password"></el-input>
            </el-form-item>
            <el-form-item label="图形码">
              <el-input v-model="pwdform.imageVerification" placeholder="请输入图形码">
              </el-input>
              <img style="width:93px;height:47px;left:286px;position: absolute;" :src="imgcode" alt="" @click="changeimgcode"/>
            </el-form-item>
            <el-form-item label="手机验证码">
              <el-row>
                <el-col :span="12">
                  <el-input v-model="pwdform.telCode" placeholder="请输入手机验证码"></el-input>
                </el-col>
                <el-col :span="4">
                  <el-button v-show="show" style="height: 41px;margin-left: -112px;font-size: 14px;margin-top: 4px;position:relative" @click="getcode(pwdform)">获取验证码</el-button>
                  <el-button class="count" v-show="!show" style="height: 41px;margin-left: -112px;font-size: 14px;margin-top: 4px;position:relative" >{{ times }} s</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
          <el-button @click="amendBtn(pwdform)" style="margin-left: 134px;">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getReaderById,
  updateReaderById,
  getPasswordById,
  telVerification
} from "@/utils/router/reader.api";
export default {
  data() {
    return {
      show: true,
      isShow: false,
      pwdShow: false,
      detailsform: {},
      Name: '',
      form: {},
      pwdform: {},
      times: "",
      timer: null,
      imgcode: "/portal/reader/imageVerification",
    };
  },
  methods: {
    getcode(row) {
      telVerification({
        tel: this.$store.state.userInfo.userName,
        imageVerification: row.imageVerification,
      }).then((res) => {
        if (res.data.code === 200) {
          const TIME_TIMES = 60;
          if (!this.timer) {
            this.times = TIME_TIMES;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.times > 0 && this.times <= TIME_TIMES) {
                this.times--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          this.$alert(res.data.message);
        }
      });
    },
    changeimgcode() {
      var num = Math.ceil(Math.random() * 10);
      this.imgcode = "/portal/reader/imageVerification?" + num;
    },
    nameBtn(row) {
      updateReaderById({
        id: this.$store.state.userInfo.userId,
        nickname: row.nickname,
      }).then((res) => {
        if (res && res.data.code === 200) {
          this.$alert("修改成功");
          location.reload();
        } else {
          this.$alert(res.data.message);
        }
      });
    },
    amendBtn(row) {
      getPasswordById({
        userName: this.$store.state.userInfo.userName,
        password: this.$md5(row.password),
        telCode: row.telCode,
      }).then((res) => {
        if (res && res.data.code === 200) {
          this.$alert("密码修改成功");
        } else {
          this.$alert(res.data.message);
        }
      });
    },
    collectBtn() {
      this.isShow = true;
    },
    unfoldBtn(row) {
      this.isShow = false;
    },
    pwdUnfold() {
      this.pwdShow = false;
    },
    pwdCollect() {
      this.pwdShow = true;
    },
  },
  created() {
    getReaderById({ id: this.$store.state.userInfo.userId }).then((res) => {
      if (res && res.data.code === 200) {
        this.detailsform = res.data.data;
        let reg = /^(\d{3})\d{4}(\d{4})$/;
        this.Name = res.data.data.userName.replace(reg, "$1****$2");

      }
    });
  },
};
</script>

<style lang="less" scoped>
.basics {
  border: 1px solid #dcdcdc;
  background-image: url("../../assets/img/reader/bg03.jpg");
  background-size: 100%;
  background-repeat: no-repeat;
  box-shadow: 0px 4px 7px 0px rgba(6, 0, 1, 0.1);
  margin-bottom: 62px;
  padding: 56px 120px;
  .basics-content {
    .basics-title {
      border-bottom: 2px solid #654719;
      padding-bottom: 20px;
      img {
        width: 32px;
        height: 24px;
        position: relative;
        top: 5px;
      }
      .title {
        color: #242424;
        font-weight: bold;
        font-size: 24px;
      }
    }
    .basics-message {
      .message-box {
        border-bottom: 1px dashed #d7d7d7;
        color: #242424;
        font-size: 20px;
        font-weight: bold;
        padding: 32px 50px 10px 70px;
        span:nth-child(2) {
          color: #d8d8d8;
          font-weight: bold;
          padding: 0 20px;
        }
        .btn {
          cursor: pointer;
          position: relative;
          left: 600px;
        }
      }
      .nickname,
      .passwd-box {
        background-color: #f6f6f6;
        margin-top: 4px;
        padding: 16px 70px 0px 70px;
        .el-button {
          width: 118px;
          height: 48px;
          background-color: #654719;
          border-radius: 6px;
          color: #fff;
          font-size: 20px;
          margin-top: 32px;
          margin-left: 106px;
          letter-spacing: 2px;
        }
        /deep/.el-input--small .el-input__inner {
          width: 358px;
          height: 48px;
          margin-left: 22px;
        }
      }
      .nickname {
        height: 166px;
      }
      .passwd-box {
        height: 302px;
        padding-left: 46px;
      }
      /deep/.el-form-item__label {
        color: #242424;
        font-size: 20px;
        font-weight: bold;
        line-height: 48px;
        padding: 0;
      }
    }
  }
}
</style>
